export default __webpack_public_path__ + "static/media/fl5.5eae7cc6.png";